import { Injectable, inject } from '@angular/core';

import { CrmConfig } from '@frontend/sports/common/client-config-data-access';
import { LocalStoreService } from '@frontend/vanilla/core';
import { RewardTokenType } from 'packages/sports/web/app/src/tokens-base/token-base.models';

import { AcquisitionContext, AcquisitionContextType, IRewardToken } from '../reward-tokens.model';
import { getAcquisitionRewardToken } from './reward-tokens.utils';

@Injectable({ providedIn: 'root' })
export class AcquisitionRewardTokenService {
    private readonly acquisitionRewardNotificationKey = 'AcquisitionRewardNotification';
    private localStoreService = inject(LocalStoreService);
    private tokensConfig = inject(CrmConfig);

    private readonly defaultContext: AcquisitionContext = {
        acquisitionNotificationShown: false,
        autoApplyNotificationShown: false,
        deselectedByUser: false,
        rewardAutoApplied: false,
        AddWelcomeOfferNotificationShown: false,
    };

    getAcquisitionRewardNotification(): AcquisitionContext {
        return this.localStoreService.get(this.acquisitionRewardNotificationKey) ?? this.defaultContext;
    }

    storeAcquisitionRewardNotification(acquisitionCookieType: AcquisitionContextType): void {
        let rewardState = this.getAcquisitionRewardNotification();

        switch (acquisitionCookieType) {
            case AcquisitionContextType.BannerTooltip:
                rewardState = { ...rewardState, acquisitionNotificationShown: true };
                break;
            case AcquisitionContextType.AutoApplyTooltip:
                rewardState = { ...rewardState, autoApplyNotificationShown: true };
                break;
            case AcquisitionContextType.DeselectedByUser:
                rewardState = { ...rewardState, deselectedByUser: true };
                break;
            case AcquisitionContextType.AutoApply:
                rewardState = { ...rewardState, rewardAutoApplied: true };
                break;
            case AcquisitionContextType.AddWelcomeOffer:
                rewardState = { ...rewardState, AddWelcomeOfferNotificationShown: true };
                break;
        }

        this.localStoreService.set(this.acquisitionRewardNotificationKey, rewardState);
    }

    shouldShowAcquisitionRewardNotification(tokens: IRewardToken[]): boolean {
        const acquisitionNotificationState = this.getAcquisitionRewardNotification();

        return !!getAcquisitionRewardToken(tokens) && !acquisitionNotificationState?.acquisitionNotificationShown;
    }

    getTokenIcon(rewardTokenType: RewardTokenType): string | undefined {
        switch (rewardTokenType) {
            case RewardTokenType.FreeBet:
                return this.tokensConfig.tokens.icons.freeBet;
            case RewardTokenType.RiskFreeBet:
                return this.tokensConfig.tokens.icons.riskFree;
            case RewardTokenType.OddsBoost:
                return this.tokensConfig.tokens.icons.oddsBoost;
            case RewardTokenType.BetAndGet:
                return this.tokensConfig.tokens.icons.betAndGet;
            default:
                return;
        }
    }
}
